import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPackageBox = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M54 20.2 42 26.7M32 32 10 20.2M32 32l10-5.3M20.4 14.6l-9.5 5.2c-.8.5-1.2.7-1.5 1-.3.3-.5.7-.6 1.1-.1.4-.1.9-.1 1.8v19.8c0 .9 0 1.4.1 1.8.1.4.3.8.6 1.1.3.3.7.6 1.5 1L30 58c.7.4 1.1.6 1.5.7.3.1.7.1 1 0 .4-.1.8-.3 1.5-.7l19.1-10.6c.8-.4 1.2-.7 1.5-1 .3-.3.5-.7.6-1.1.1-.4.1-.9.1-1.8V23.7c0-.9 0-1.4-.1-1.8-.1-.4-.3-.8-.6-1.1-.3-.3-.7-.5-1.5-1L34 9.2c-.7-.4-1.1-.6-1.5-.7-.3-.1-.7-.1-1 0-.4.1-.8.3-1.5.7l-9.6 5.4Zm0 0L42 26.7M32 32v26",
		stroke: "currentColor",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPackageBox;
